import { takeLatest, takeEvery, call, put } from "redux-saga/effects";
import { get } from "lodash";
import {
  defaultReturn
  , fillDictionary
  , makePayload
  , generateDefaultActions
  , requestSaga
  , callbackSaga
  , subKeySaga
  , handleCallback
  , multipleObjectReturn
} from "shared-utility/store/utils/helpers";

import { ToastSuccess, ToastError } from "../../components/Global/Toasts/Toasty";
import { downloadXLSFile, uploadFile } from "../../utils/api";

// ACTIONS

export const PROPERTY_DETAIL_DELETE = generateDefaultActions("PROPERTY_DETAIL_DELETE");
export const deleteProperty = payload => makePayload(PROPERTY_DETAIL_DELETE.value, payload);
function* deletePropertySaga(payload) {
  const callback = handleCallback(payload);
  const url = `/properties/deleteProperty/${payload.propertyId}/${payload.dealId}`;
  yield requestSaga(PROPERTY_DETAIL_DELETE, url, "DELETE");
  yield callback();
}

export const PROPERTY_DETAIL_GET_NEW_PROPERTY = generateDefaultActions("PROPERTY_DETAIL_GET_NEW_PROPERTY");
export const propertyDetailGetNewProperty = payload => makePayload(PROPERTY_DETAIL_GET_NEW_PROPERTY.value, payload);
function* propertyDetailGetNewPropertySaga(payload) {
  const url = `/properties/new/${payload.dealId}`;
  yield requestSaga(PROPERTY_DETAIL_GET_NEW_PROPERTY, url, "GET");
}

export const PROPERTY_DETAIL_GET_NEW_PROPERTY_OWNER = generateDefaultActions("PROPERTY_DETAIL_GET_NEW_PROPERTY_OWNER");
export const propertyDetailGetNewPropertyOwner = payload => makePayload(PROPERTY_DETAIL_GET_NEW_PROPERTY_OWNER.value, payload);
function* propertyDetailGetNewPropertyOwnerSaga(payload) {
  const { propertyId, principleType, callback } = payload;
  const url = `/properties/newOwner/${propertyId}/${principleType}`;
  yield requestSaga(PROPERTY_DETAIL_GET_NEW_PROPERTY_OWNER, url, "GET");
  if (callback) {
    callback();
  }
}
export const PROPERTY_DETAIL_CREATE_PROPERTY = generateDefaultActions("PROPERTY_DETAIL_CREATE_PROPERTY");
export const propertyDetailCreateProperty = payload => makePayload(PROPERTY_DETAIL_CREATE_PROPERTY.value, payload);
function* propertyDetailCreatePropertySaga(payload) {
  const { property, dealId, callback } = payload;
  const url = `/deals/${dealId}/createProperty`;
  yield requestSaga(PROPERTY_DETAIL_CREATE_PROPERTY, url, "POST", property);
  if (callback) {
    callback();
  }
}
export const PROPERTY_DETAIL_GET_PROPERTY = generateDefaultActions("PROPERTY_DETAIL_GET_PROPERTY");
export const propertyDetailGetProperty = payload => makePayload(PROPERTY_DETAIL_GET_PROPERTY.value, payload);
function* propertyDetailGetPropertySaga(payload) {
  const url = `/properties/${payload.propertyId}`;
  yield requestSaga(PROPERTY_DETAIL_GET_PROPERTY, url, "GET");
}

export const PROPERTY_DETAIL_GET_DEAL_METRICS = generateDefaultActions("PROPERTY_DETAIL_GET_DEAL_METRICS");
export const propertyDetailGetDealMetrics = payload => makePayload(PROPERTY_DETAIL_GET_DEAL_METRICS.value, payload);
function* propertyDetailGetDealMetricsSaga(payload) {
  const { propertyId, dealMetrics } = payload;
  const url = `/properties/${propertyId}/dealMetrics`;

  yield requestSaga(PROPERTY_DETAIL_GET_DEAL_METRICS, url, "POST", { dealMetrics });
}

export const PROPERTY_DETAIL_UPDATE_PROPERTY = generateDefaultActions("PROPERTY_DETAIL_UPDATE_PROPERTY");
export const updateProperty = payload => makePayload(PROPERTY_DETAIL_UPDATE_PROPERTY.value, payload);
function* updatePropertySaga(payload) {
  const url = `/updateProperty/${payload.id}`;
  const filteredPayload = {
    ...payload
  };
  delete filteredPayload.type;
  const requestSaga = callbackSaga(payload.callback);
  yield requestSaga(PROPERTY_DETAIL_UPDATE_PROPERTY, url, "POST", filteredPayload);
}

export const PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY = generateDefaultActions("PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY");
export const getContactsByCompany = payload => makePayload(PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY.value, payload);
function* getContactsByCompanySaga(payload) {
  const { companyId, subKey } = payload;
  const url = `/contactsByCompany/?companyId=${companyId}`;
  const requestSaga = subKeySaga(subKey);
  yield requestSaga(PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY, url);
}

export const PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID = generateDefaultActions("PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID");
export const getCompaniesByTypeId = payload => makePayload(PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID.value, payload);
function* getCompaniesByTypeIdSaga(payload) {
  const { companyTypeId, subKey } = payload;
  const url = `/companiesByTypeId/${companyTypeId}`;
  const key = subKey || "companyContacts";
  const requestSaga = subKeySaga(key);
  yield requestSaga(PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID, url);
}

export const PROPERTY_DETAIL_GET_SALES_BROKERS = generateDefaultActions("PROPERTY_DETAIL_GET_SALES_BROKERS");
export const getSalesBrokers = payload => makePayload(PROPERTY_DETAIL_GET_SALES_BROKERS.value, payload);
function* getSalesBrokersSaga() {
  yield requestSaga(PROPERTY_DETAIL_GET_SALES_BROKERS, "/getSalesBrokers");
}

export const PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID = generateDefaultActions("PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID");
export const getPropertiesAndProjectionsOfDealByPropertyId = payload => makePayload(PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID.value, payload);
function* getPropertiesAndProjectionsOfDealByPropertyIdSaga(payload) {
  const { propertyId } = payload;
  const url = "/getPropertiesAndProjectionsOfDealByPropertyId";
  yield requestSaga(PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID, url, "POST", { propertyId });
}

export const PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS = generateDefaultActions("PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS");
export const downloadProjections = payload => makePayload(PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS.value, payload);
function* downloadProjectionsSaga(payload) {
  try {
    const url = payload.edit ?
      `/propertyProjections/${payload.propertyId}?edit=${payload.edit}&asOfDate=${payload.asOfDate}&periodType=${payload.periodType}&term=${payload.term}` :
      `/propertyProjections/${payload.propertyId}`;
    const response = yield call(downloadXLSFile, url, "GET", undefined, "property-projections.xlsx");
    yield put({ type: PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS.success, payload: response });
  } catch (error) {
    yield put({ type: PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS.failure, error });
  }
}

const PROPERTY_DETAIL_EXTRACT_PROJECTIONS = generateDefaultActions("UPLOAD_PROJECTIONS");
export const extractProjections = payload => makePayload(PROPERTY_DETAIL_EXTRACT_PROJECTIONS.value, payload);
function* extractProjectionsSaga(payload) {
  try {
    payload.url = "/extractPropertyProjections";

    const response = yield call(uploadFile, payload, "POST");

    yield put({ type: PROPERTY_DETAIL_EXTRACT_PROJECTIONS.success, payload: response });
    const url = "/saveCustomProjection";
    yield requestSaga(PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION, url, "POST", { response, payload });
  } catch (error) {
    const userFriendlyError = get(error, "response.data.error", "Upload encountered error. Please choose a different file and try again.");
    yield put({ type: PROPERTY_DETAIL_EXTRACT_PROJECTIONS.failure, payload: { userFriendlyError, error } });
  }
}

const PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION = generateDefaultActions("PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION");
export const saveCustomProjection = payload => makePayload(PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION.value, payload);
function* saveCustomProjectionSaga(payload) {
  const url = "/saveCustomProjection";
  yield requestSaga(PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION, url, "POST", payload);
}

// REDUCER

const initialState = {
  propertyData: { property: null, ancillary: null },
  deal: null,
  newPropertyId: null,
  companyContacts: null,
  propertyProjections: null
};

export function propertyDetailReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case PROPERTY_DETAIL_DELETE.success:
      ToastSuccess("Successfully Deleted");

      return defaultReturn(state);

    case PROPERTY_DETAIL_GET_NEW_PROPERTY.success:
    case PROPERTY_DETAIL_GET_PROPERTY.success:
      return multipleObjectReturn(state, ["propertyData", "guestPermission", "isLoading"], [payload.data, payload.guestPermission, false]);

    case PROPERTY_DETAIL_GET_DEAL_METRICS.success:
      return defaultReturn(state, payload.data, "deal");

    case PROPERTY_DETAIL_CREATE_PROPERTY.success:
      return defaultReturn(state, payload.propertyId, "newPropertyId");

    case PROPERTY_DETAIL_UPDATE_PROPERTY.success:
      ToastSuccess("Saving, please wait");

      return defaultReturn(state, true, "isLoading");

    case PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY.success:
      const results = payload.data || [];

      return defaultReturn(state, results, subKey);

    case PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID.success:
      return defaultReturn(state, payload.data, "sponsors");

    case PROPERTY_DETAIL_GET_SALES_BROKERS.success:
      return defaultReturn(state, payload, "salesBrokerCompany");

    case PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID.success:
      return defaultReturn(state, payload, "propertyProjections");

    case PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID.failure:
      return defaultReturn(state, null, "propertyProjections");

    case PROPERTY_DETAIL_EXTRACT_PROJECTIONS.failure:
      ToastError("Custom Projection Fail");

      return state;

    case PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION.success:
      ToastSuccess("Custom Projection Saved");

      return state;
    case PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION.failure:
      ToastError("Custom Projection Fail");

      return state;

    default:
      return state;
  }
}

// SAGA

export function* propertyDetailSaga() {
  yield takeLatest(PROPERTY_DETAIL_GET_NEW_PROPERTY.value, propertyDetailGetNewPropertySaga);
  yield takeLatest(PROPERTY_DETAIL_GET_PROPERTY.value, propertyDetailGetPropertySaga);
  yield takeLatest(PROPERTY_DETAIL_GET_DEAL_METRICS.value, propertyDetailGetDealMetricsSaga);
  yield takeLatest(PROPERTY_DETAIL_UPDATE_PROPERTY.value, updatePropertySaga);
  yield takeLatest(PROPERTY_DETAIL_CREATE_PROPERTY.value, propertyDetailCreatePropertySaga);
  yield takeLatest(PROPERTY_DETAIL_GET_NEW_PROPERTY_OWNER.value, propertyDetailGetNewPropertyOwnerSaga);
  yield takeLatest(PROPERTY_DETAIL_GET_CONTACTS_BY_COMPANY.value, getContactsByCompanySaga);
  yield takeEvery(PROPERTY_DETAIL_GET_COMPANIES_BY_TYPE_ID.value, getCompaniesByTypeIdSaga);
  yield takeEvery(PROPERTY_DETAIL_GET_SALES_BROKERS.value, getSalesBrokersSaga);
  yield takeLatest(PROPERTY_DETAIL_GET_PROPERTIES_AND_PROJECTIONS_OF_DEAL_BY_PROPERTYID.value, getPropertiesAndProjectionsOfDealByPropertyIdSaga);
  yield takeLatest(PROPERTY_DETAIL_DOWNLOAD_PROJECTIONS.value, downloadProjectionsSaga);
  yield takeLatest(PROPERTY_DETAIL_EXTRACT_PROJECTIONS.value, extractProjectionsSaga);
  yield takeLatest(PROPERTY_DETAIL_SAVE_CUSTOM_PROJECTION.value, saveCustomProjectionSaga);
  yield takeLatest(PROPERTY_DETAIL_DELETE.value, deletePropertySaga);
}
